import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { 
  Briefcase, MapPin, Clock, Users, Heart, Zap,
  Code, Brain, Megaphone, Palette, ArrowRight
} from 'lucide-react';

const openPositions = [
  {
    id: 1,
    title: 'Senior Machine Learning Engineer',
    department: 'Engineering',
    location: 'Remote',
    type: 'Full-time',
    icon: Code,
    description: 'Build and optimize ML models that power our learning platform and student recommendations.'
  },
  {
    id: 2,
    title: 'AI Curriculum Developer',
    department: 'Content',
    location: 'Remote',
    type: 'Full-time',
    icon: Brain,
    description: 'Create world-class AI/ML course content and hands-on projects for our students.'
  },
  {
    id: 3,
    title: 'Growth Marketing Manager',
    department: 'Marketing',
    location: 'Remote',
    type: 'Full-time',
    icon: Megaphone,
    description: 'Drive student acquisition and engagement through innovative marketing strategies.'
  },
  {
    id: 4,
    title: 'Product Designer',
    department: 'Design',
    location: 'Remote',
    type: 'Full-time',
    icon: Palette,
    description: 'Design intuitive learning experiences that help students achieve their goals.'
  }
];

const benefits = [
  'Competitive salary & equity',
  'Fully remote work',
  'Unlimited PTO',
  'Health, dental & vision insurance',
  'Learning & development budget',
  '401(k) matching',
  'Home office stipend',
  'Flexible working hours'
];

const CareersPage = () => {
  return (
    <div className="page careers-page">
      <Header onEnrollClick={() => window.location.href = '/pricing'} />
      
      <main className="page-content">
        <section className="page-hero careers-hero">
          <div className="container">
            <span className="section-tag">Join Our Team</span>
            <h1 className="page-title">Build the Future of AI Education</h1>
            <p className="page-subtitle">
              Help us democratize AI education and empower the next generation of AI professionals
            </p>
          </div>
        </section>

        {/* Why Join Us */}
        <section className="why-join-section">
          <div className="container">
            <h2 className="section-title">Why WSafe AI ML?</h2>
            <div className="why-grid">
              <div className="why-card">
                <Zap className="why-icon" />
                <h3>Mission-Driven</h3>
                <p>We're on a mission to make AI education accessible to everyone, everywhere.</p>
              </div>
              <div className="why-card">
                <Users className="why-icon" />
                <h3>Amazing Team</h3>
                <p>Work with talented individuals from Google, Meta, OpenAI, and top universities.</p>
              </div>
              <div className="why-card">
                <Heart className="why-icon" />
                <h3>Real Impact</h3>
                <p>Help 12,500+ students transform their careers and break into AI.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="benefits-section">
          <div className="container">
            <h2 className="section-title">Benefits & Perks</h2>
            <div className="benefits-grid">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="benefit-item">
                  <span className="benefit-check">✓</span>
                  <span>{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Open Positions */}
        <section className="positions-section">
          <div className="container">
            <h2 className="section-title">Open Positions</h2>
            <div className="positions-grid">
              {openPositions.map((position) => (
                <div key={position.id} className="position-card">
                  <div className="position-icon-wrapper">
                    <position.icon className="position-icon" />
                  </div>
                  <div className="position-content">
                    <h3 className="position-title">{position.title}</h3>
                    <div className="position-meta">
                      <span><Briefcase size={14} /> {position.department}</span>
                      <span><MapPin size={14} /> {position.location}</span>
                      <span><Clock size={14} /> {position.type}</span>
                    </div>
                    <p className="position-description">{position.description}</p>
                    <Button className="btn-secondary position-btn">
                      Apply Now <ArrowRight size={16} />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="careers-cta">
          <div className="container">
            <div className="cta-card">
              <h2>Don't See Your Role?</h2>
              <p>We're always looking for talented people. Send us your resume!</p>
              <Link to="/contact">
                <Button className="btn-primary">Get in Touch</Button>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CareersPage;
